import { ISalaryDataRequest, ISalaryDataResponse } from "../shared/types";

import { BaseServiceLegacy } from "./base.service.legacy";

export class SalaryDataService extends BaseServiceLegacy<
  ISalaryDataResponse,
  ISalaryDataRequest
> {
  constructor() {
    super("/salary-data");
  }
}
